{
  "$id": "wealthlane://forms/psu-award/rules",
  "effects": [
    {
      "id": "participantNameCascade",
      "watch": "#/properties/participantId",
      "set": {
        "#/properties/firstName": {
          "operator": "optionProp",
          "field": "#/properties/participantId",
          "prop": "firstName"
        },
        "#/properties/middleName": {
          "operator": "optionProp",
          "field": "#/properties/participantId",
          "prop": "middleName"
        },
        "#/properties/lastName": {
          "operator": "optionProp",
          "field": "#/properties/participantId",
          "prop": "lastName"
        },
        "#/properties/employeeId": {
          "operator": "optionProp",
          "field": "#/properties/participantId",
          "prop": "employeeId"
        }
      }
    },
    {
      "id": "computeGrantPrice",
      "watch": [
        "#/properties/issuedUnits",
        "#/properties/fmvAtGrant"
      ],
      "set": {
        "#/properties/grantPrice": {
          "operator": "multiply",
          "operands": [
            "#/properties/issuedUnits",
            "#/properties/fmvAtGrant"
          ]
        }
      }
    },
    {
      "id": "computeGrantValueCreate",
      "watch": [
        "#/properties/issuedUnits",
        "#/properties/fmvAtGrant"
      ],
      "mode": "create",
      "set": {
        "#/properties/grantValue": {
          "operator": "multiply",
          "operands": [
            "#/properties/issuedUnits",
            "#/properties/fmvAtGrant"
          ]
        }
      }
    },
    {
      "id": "clearAcceptanceOnReject",
      "watch": "#/properties/isAccepted",
      "condition": {
        "field": "#/properties/isAccepted",
        "notEquals": true
      },
      "clear": [
        "#/properties/acceptanceDate",
        "#/properties/awardAcceptanceDocumentInput"
      ]
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/clearAdjustmentFields",
      "id": "clearAdjustmentFields",
      "bind": { "prefix": "#" }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/clearCancelShareTypeOnManualTargetCancelled",
      "id": "clearCancelShareTypeOnManualTargetCancelled",
      "bind": { "prefix": "#" }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/copyAsOfToResidual",
      "id": "copyAsOfToResidual",
      "bind": { "prefix": "#" }
    }
  ],
  "observers": [
    {
      "$ref": "shared://rules/award-adjustment#templates/resolveAdjustmentMethodOnMethodType",
      "id": "resolveAdjustmentMethodOnMethodType",
      "bind": { "prefix": "#" }
    },
    {
      "id": "grantCascade",
      "watch": "#/properties/grantId",
      "lookup": {
        "actionId": "FETCH_PSU_GRANT_DETAILS",
        "paramField": "grantId"
      },
      "mapTo": {
        "planName": "#/properties/planName",
        "planId": "#/properties/planId",
        "planTypeId": "#/properties/planTypeId",
        "planType": "#/properties/planType",
        "grantName": "#/properties/grantName",
        "grantIssueDate": "#/properties/grantIssueDate",
        "isOffline": "#/properties/isOffline",
        "poolId": "#/properties/poolId",
        "vestingTemplateId": "#/properties/vestingTemplateId",
        "vestingTemplateName": "#/properties/vestingTemplateName",
        "performanceRuleName": "#/properties/performanceRuleName",
        "performanceRuleId": "#/properties/performanceRuleId"
      },
      "debounceMs": 300
    },
    {
      "id": "fmvLookup",
      "watch": "#/properties/grantIssueDate",
      "condition": {
        "field": "#/properties/grantIssueDate",
        "notEmpty": true
      },
      "lookup": {
        "actionId": "FETCH_FMV_MARKET_PRICE_PSU",
        "params": {
          "awardType": "PSU",
          "date": "#/properties/grantIssueDate",
          "issuedUnits": "#/properties/issuedUnits"
        },
        "skipNull": true
      },
      "mapTo": {
        "fmv": "#/properties/fmvAtGrant",
        "grantPrice": "#/properties/grantPrice"
      },
      "debounceMs": 300
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/adjustAwardOnCancelShareType",
      "id": "adjustAwardOnCancelShareType",
      "bind": { "prefix": "#", "adjustmentActionId": "FETCH_PSU_AWARD_ADJUSTMENT" }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/adjustAwardOnMethodType",
      "id": "adjustAwardOnMethodType",
      "bind": { "prefix": "#", "adjustmentActionId": "FETCH_PSU_AWARD_ADJUSTMENT" }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/adjustAwardOnAsOfDate",
      "id": "adjustAwardOnAsOfDate",
      "bind": { "prefix": "#", "adjustmentActionId": "FETCH_PSU_AWARD_ADJUSTMENT" }
    }
  ],
  "rules": [
    {
      "id": "rule_grantReason_noBlank",
      "target": "#/properties/grantReason",
      "rule": "noBlank",
      "message": "No blank spaces"
    },
    {
      "id": "rule_grantReason_noDoubleSpace",
      "target": "#/properties/grantReason",
      "rule": "noDoubleSpace",
      "message": "No consecutive spaces"
    },
    {
      "id": "rule_notes_noBlank",
      "target": "#/properties/notes",
      "rule": "noBlank",
      "message": "No blank spaces"
    },
    {
      "id": "rule_notes_noDoubleSpace",
      "target": "#/properties/notes",
      "rule": "noDoubleSpace",
      "message": "No consecutive spaces"
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/rule_asOfDate_required",
      "id": "rule_asOfDate_required",
      "bind": { "prefix": "#" }
    },
    {
      "$ref": "shared://rules/award-adjustment#templates/rule_targetCancelled_required",
      "id": "rule_targetCancelled_required",
      "bind": { "prefix": "#" }
    }
  ]
}
